import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TVoidTransactionRequestSchema,
  TVoidTransactionResponseSchema,
} from "./voidTransaction.schema";

export const voidTransaction = (axios: IAxiosInstance) => {
  return async (body: TVoidTransactionRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TVoidTransactionResponseSchema>
    >(`/api/business-cards/transaction/void`, body);

    return response.data;
  };
};
